/* import __COLOCATED_TEMPLATE__ from './text.hbs'; */
import UserFieldBase from "./base";
import TEMPLATE from "./text.hbs";
import { setComponentTemplate } from "@ember/component";
export default class UserFieldText extends UserFieldBase {}
setComponentTemplate(TEMPLATE, UserFieldText);